import React, { useEffect, useState } from 'react';
import { CookieConsentCategories, getStoredCookieConsent, storeCookieConsent } from '../utils/legal';

const CookieSettings: React.FC = () => {
  const [consent, setConsent] = useState<CookieConsentCategories>({
    necessary: true,
    preferences: false,
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    const saved = getStoredCookieConsent();
    if (saved) setConsent(saved);
  }, []);

  const save = () => {
    storeCookieConsent(consent);
    alert('Your cookie preferences have been saved.');
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-8 text-left">
      <h1 className="text-3xl font-bold mb-4">Cookie Settings</h1>
      <p className="text-gray-700 mb-6">Manage your preferences. Necessary cookies are always on.</p>
      <div className="space-y-4">
        <label className="flex items-center gap-3">
          <input type="checkbox" checked disabled />
          <div>
            <div className="font-medium">Necessary</div>
            <div className="text-gray-600 text-sm">Required for core functionality.</div>
          </div>
        </label>
        <label className="flex items-center gap-3">
          <input type="checkbox" checked={consent.preferences} onChange={(e) => setConsent({ ...consent, preferences: e.target.checked })} />
          <div>
            <div className="font-medium">Preferences</div>
            <div className="text-gray-600 text-sm">Remember your settings.</div>
          </div>
        </label>
        <label className="flex items-center gap-3">
          <input type="checkbox" checked={consent.analytics} onChange={(e) => setConsent({ ...consent, analytics: e.target.checked })} />
          <div>
            <div className="font-medium">Analytics</div>
            <div className="text-gray-600 text-sm">Help us improve the site.</div>
          </div>
        </label>
        <label className="flex items-center gap-3">
          <input type="checkbox" checked={consent.marketing} onChange={(e) => setConsent({ ...consent, marketing: e.target.checked })} />
          <div>
            <div className="font-medium">Marketing</div>
            <div className="text-gray-600 text-sm">Personalize offers and measure campaigns.</div>
          </div>
        </label>
      </div>
      <button onClick={save} className="mt-6 px-4 py-2 rounded bg-red-600 hover:bg-red-500 text-white">Save preferences</button>
    </div>
  );
};

export default CookieSettings;





